// Server-composed sentences, dressed in the provenance voices.
//
// The brief endpoint ships whole strings (ATTEST's determinism mandate: the page ARRANGES,
// it never derives) and those strings mix registers — "DOC-021 open 14 d" is an identity and
// a quantity in one line. Dressing is presentation only: it wraps the ref-shaped tokens in
// .src-ref so mono keeps meaning "checkable identity" (LAW 1) without altering one character
// of what the server said. Split, never rewritten — the concatenation of the parts is the
// input, always.
import { Fragment, type ReactNode } from 'react';

/** REQ-014, DOC-021, TE-7, G1 … — a ref is letters, an optional dash, digits. */
const REF = /\b(?:[A-Z][A-Z0-9]{0,5}-\d{1,5}|G[0-8])\b/g;

/** Wrap every ref-shaped token of `text` in .src-ref; everything else is left alone. */
export function dressRefs(text: string): ReactNode {
  const parts: ReactNode[] = [];
  let last = 0;
  for (const match of text.matchAll(REF)) {
    const at = match.index ?? 0;
    if (at > last) parts.push(text.slice(last, at));
    parts.push(<span key={`${at}-${match[0]}`} className="src-ref">{match[0]}</span>);
    last = at + match[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts.map((p, i) => <Fragment key={i}>{p}</Fragment>);
}

/** The same, as an element — for the places a ReactNode reads better than a call. */
export default function BriefText({ text }: { text: string }) {
  return <>{dressRefs(text)}</>;
}
